import './index.css';
import PhiHome from './home/home';
import React from 'react';
import reportWebVitals from './reportWebVitals';
import SessionMenu from './mirror-cast/session/menu';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCECKFuKu39Es_l347tI4ObmrlEj9IM7BA",
  authDomain: "phi-web-da3dd.firebaseapp.com",
  projectId: "phi-web-da3dd",
  storageBucket: "phi-web-da3dd.firebasestorage.app",
  messagingSenderId: "547414454969",
  appId: "1:547414454969:web:a48501264df25958b3e168",
  measurementId: "G-SZRYWZL414"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const root = createRoot(document.getElementById('root'));

root.render(
  <Router>
    <Routes>
      <Route path="/" element={<PhiHome/>} />
      <Route path="/mirror-cast/:sessionId" element={<SessionMenu/>} />
    </Routes>
  </Router>
);

reportWebVitals();
